/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateSerieLangRequestViewModel } from "../types/CreateSerieLangRequestViewModel.ts";

export const createSerieLangRequestViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe("Código do idioma (cultura) da tradução.")
    .nullish(),
  title: z.string().describe("Título da série neste idioma.").nullish(),
  resumee: z
    .string()
    .describe("Resumo da série neste idioma. Opcional.")
    .nullish(),
  header: z
    .string()
    .describe("Cabeçalho da série neste idioma. Opcional.")
    .nullish(),
}) as unknown as ToZod<CreateSerieLangRequestViewModel>;
